import React from 'react';
import { defineMessages } from 'react-intl-next';

import { MiniSectionMessage } from '../UpsellLooknFeel/MiniSectionMessage';
import { ConfluenceEdition } from '../Upgrade/__types__/waitForEditionChangeQuery';

export const i18n = defineMessages({
	body: {
		id: 'change-edition.inline-message.share-and-restrict-dialog.body',
		defaultMessage: 'You can restrict this content to specific people on paid plans.',
		description: 'inline upsell message body',
	},
	learnMoreLink: {
		id: 'change-edition.inline-message.share-and-restrict-dialog.learn-more-link',
		defaultMessage: 'Learn more',
		description:
			'The text of the hyperlink which takes the user to a page explaining the feature Page Restrictions',
	},
});

const SAC_CONTENT_PERMS_MANAGEMENT_DOCUMENTATION =
	'https://support.atlassian.com/confluence-cloud/docs/manage-permissions-on-the-page-level/';

export const ChangeEditionInlineMessageShareAndRestrict = ({
	source,
	customPadding,
	href = SAC_CONTENT_PERMS_MANAGEMENT_DOCUMENTATION,
}: {
	source: string;
	customPadding?: string;
	href?: string;
}) => {
	const learnMoreLink = {
		href,
		actionSubjectId: source,
		messageDescriptor: i18n.learnMoreLink,
	};

	return (
		<MiniSectionMessage
			source={source}
			messageContent={i18n.body}
			withGradient={false}
			customPadding={customPadding}
			learnMoreLink={learnMoreLink}
			targetEdition={ConfluenceEdition.STANDARD}
		/>
	);
};
